import { Teaser } from "@app/vehicles/_models";

export class TeaserEligibilityContext {
    teaser: Teaser
}
